module.exports = __webpack_public_path__ + "img/lookbook_9_center_back.a05c489e.png";